// Development-only mapping. Production URLs and signed query parameters stay unchanged.
export function localGameEntry(url, enabled, origin) {
  if (!enabled || !url) return url
  try {
    const target = new URL(url)
    if (target.origin === 'https://game.etuw.cn' && target.pathname === '/test/ds.html' && !target.username && !target.password) {
      return new URL('/game-entry/test/ds.html' + target.search + target.hash, origin).href
    }
  } catch (_) { /* Leave unsupported provider URLs to the normal host flow. */ }
  return url
}
